import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Lock } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { formatApiErrorDetail, LOGO_URL } from "../lib/api";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Selamat kembali!");
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Log masuk gagal");
    } finally {
      setLoading(false);
    }
  };

  const inputCls =
    "w-full bg-slate-900 border border-slate-800 rounded-md px-4 py-3 text-sm text-white placeholder:text-slate-500 focus:outline-none focus:ring-2 focus:ring-orange-500";

  return (
    <div className="min-h-screen bg-slate-950 flex items-center justify-center px-6" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="bg-white rounded-lg p-3 inline-block mb-4">
            <img src={LOGO_URL} alt="TMG" className="h-12 w-auto" />
          </div>
          <h1 className="font-heading font-bold text-white text-2xl">Panel Admin</h1>
          <p className="text-slate-400 text-sm mt-1">Tanjung Marina Global Sdn. Bhd.</p>
        </div>
        <form onSubmit={submit} className="bg-slate-900/60 border border-white/10 rounded-xl p-8 space-y-4" data-testid="admin-login-form">
          <input
            data-testid="login-email-input"
            required
            type="email"
            placeholder="Emel admin"
            className={inputCls}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <input
            data-testid="login-password-input"
            required
            type="password"
            placeholder="Kata laluan"
            className={inputCls}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <button
            type="submit"
            disabled={loading}
            data-testid="login-submit-btn"
            className="w-full bg-orange-600 hover:bg-orange-700 disabled:opacity-60 text-white font-semibold py-3.5 rounded-full transition-all flex items-center justify-center gap-2"
          >
            <Lock size={16} /> {loading ? "Log masuk..." : "Log Masuk"}
          </button>
        </form>
        <a href="/" className="block text-center text-slate-500 hover:text-orange-500 text-sm mt-6 transition-colors">
          ← Kembali ke laman utama
        </a>
      </div>
    </div>
  );
}
